import {z} from 'zod';
import {emailRegex} from '../../../shared/services/emailValidation';

export const REQUIRED_VALIDATION_MSG = '必須項目です';
export const MAIL_ADDRESS_VALIDATION_MSG =
  'メールアドレスの形式で入力してください';
export const MICROSOFT_MAIL_VALIDATION_MSG =
  '現在、Microsoftのメールアドレス（msn、hotmail、outlook、live）はご利用になれません';
export const BADREQUEST_VALIDATION_MSG = '入力値が正しくありません';

export const PostRemindPassSchema = z.object({
  email: z
    .string()
    .regex(/@(?!(msn|hotmail|outlook))/, MICROSOFT_MAIL_VALIDATION_MSG)
    .regex(emailRegex, MAIL_ADDRESS_VALIDATION_MSG)
    .min(1, {message: REQUIRED_VALIDATION_MSG}),
  lastName: z.string().min(1, {message: '必須項目です'}),
  firstName: z.string().min(1, {message: '必須項目です'}),
  year: z.string().min(1, {message: '必須項目です'}),
  month: z.string().min(1, {message: '必須項目です'}),
  day: z.string().min(1, {message: '必須項目です'}),
});
